//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import "@/mixins/global";
import chartOTP from "../components/chartOTP";
import axios, { CancelToken } from "axios";
import ChartOTP from "../components/chartOTP.vue";
export default {
  components: {
    chartOTP,
  },
  data() {
    return {
      chartTHNIKEDoc: {
        ALL: [],
        NAY11: [],
        NAY12: [],
        NAY13: [],
      },
      chartTHNIKESample: {
        ALL: [],
        NAY11: [],
        NAY12: [],
        NAY13: [],
      },
      chartVNNIKEDoc: {
        ALL: [],
        NAY11: [],
        NAY12: [],
      },
      chartVNNIKESample: {
        ALL: [],
        NAY11: [],
        NAY12: [],
      },

      ps: "202040",
      pe: "202052",
      api_th_nike_doc:`${this.$apiFix}OTP_NIKE.php/th_nike_doc`,
        // "http://localhost:9000/nygcontrolroom/OTP_NIKE.php/th_nike_doc",
      api_th_nike_sample:`${this.$apiFix}OTP_NIKE.php/th_nike_sample`,
        // "http://localhost:9000/nygcontrolroom/OTP_NIKE.php/th_nike_sample",
      api_vn_nike_doc:`${this.$apiFix}OTP_NIKE.php/vn_nike_doc`,
        // "http://localhost:9000/nygcontrolroom/OTP_NIKE.php/vn_nike_doc",
      api_vn_nike_sample:`${this.$apiFix}OTP_NIKE.php/vn_nike_sample`,
        // "http://localhost:9000/nygcontrolroom/OTP_NIKE.php/vn_nike_sample",
    };
  },
  async mounted() {
    this.THnikeDoc();
    this.THnikeSample();
    this.VNnikeDoc();
    this.VNnikeSample();
  },
  methods: {
    goPage(routerName) {
      this.$router.push({
        name: routerName,
      });
    },

    THnikeDoc() {
      axios
        .get(`${this.api_th_nike_doc}?ps=${this.ps}&pe=${this.pe}&team=`)
        .then((response) => {
          this.chartTHNIKEDoc.ALL = response.data;
        });
      axios
        .get(`${this.api_th_nike_doc}?ps=${this.ps}&pe=${this.pe}&team=NAY1-1`)
        .then((response) => {
          this.chartTHNIKEDoc.NAY11 = response.data;
        });
      axios
        .get(`${this.api_th_nike_doc}?ps=${this.ps}&pe=${this.pe}&team=NAY1-2`)
        .then((response) => {
          this.chartTHNIKEDoc.NAY12 = response.data;
        });
      axios
        .get(`${this.api_th_nike_doc}?ps=${this.ps}&pe=${this.pe}&team=NAY1-3`)
        .then((response) => {
          this.chartTHNIKEDoc.NAY13 = response.data;
        });
    },
    THnikeSample() {
      axios
        .get(`${this.api_th_nike_sample}?ps=${this.ps}&pe=${this.pe}&team=`)
        .then((response) => {
          this.chartTHNIKESample.ALL = response.data;
        });
      axios
        .get(
          `${this.api_th_nike_sample}?ps=${this.ps}&pe=${this.pe}&team=NAY1-1`
        )
        .then((response) => {
          this.chartTHNIKESample.NAY11 = response.data;
        });
      axios
        .get(
          `${this.api_th_nike_sample}?ps=${this.ps}&pe=${this.pe}&team=NAY1-2`
        )
        .then((response) => {
          this.chartTHNIKESample.NAY12 = response.data;
        });
      axios
        .get(
          `${this.api_th_nike_sample}?ps=${this.ps}&pe=${this.pe}&team=NAY1-3`
        )
        .then((response) => {
          this.chartTHNIKESample.NAY13 = response.data;
        });
    },

    VNnikeDoc() {
      axios
        .get(`${this.api_vn_nike_doc}?ps=${this.ps}&pe=${this.pe}&team=`)
        .then((response) => {
          this.chartVNNIKEDoc.ALL = response.data;
        });
      axios
        .get(`${this.api_vn_nike_doc}?ps=${this.ps}&pe=${this.pe}&team=NAY1-1`)
        .then((response) => {
          this.chartVNNIKEDoc.NAY11 = response.data;
        });
      axios
        .get(`${this.api_vn_nike_doc}?ps=${this.ps}&pe=${this.pe}&team=NAY1-2`)
        .then((response) => {
          this.chartVNNIKEDoc.NAY12 = response.data;
        });
    },
    VNnikeSample() {
      axios
        .get(`${this.api_vn_nike_sample}?ps=${this.ps}&pe=${this.pe}&team=`)
        .then((response) => {
          this.chartVNNIKESample.ALL = response.data;
        });
      axios
        .get(
          `${this.api_vn_nike_sample}?ps=${this.ps}&pe=${this.pe}&team=NAY1-1`
        )
        .then((response) => {
          this.chartVNNIKESample.NAY11 = response.data;
        });
      axios
        .get(
          `${this.api_vn_nike_sample}?ps=${this.ps}&pe=${this.pe}&team=NAY1-2`
        )
        .then((response) => {
          this.chartVNNIKESample.NAY12 = response.data;
        });
    },
  },
};
